<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- 大屏头部 -->
        <div class="screenHeader">
          <div class="screenTitle">刘湾零工市场大数据看板</div>
          <div class="screenHeaderTime">
            {{ dateYear }} {{ dateDay }} {{ dateWeek }}
          </div>
          <div class="userInfo">
            <span>您好，欢迎使用！</span>
            <img class="userAvatar" src="../assets/default.png" alt="">
          </div>
        </div>
        <div class="headerLineBox">
          <img class="headerLine" src="@/assets/headerLine.png" alt="">
          <img class="headerLine" src="@/assets/headerLine.png" alt="">
        </div>
        <div class="screenContent">
          <div class="screenContentLeft">
            <!-- 大屏左上 -->
            <div class="conterLeft">
              <centerLeft1 ref="centerLeft1" />
            </div>

            <!-- 大屏左中 -->
            <div class="conterCenter">
              <centerLeft2 ref="centerLeft2" />
            </div>

            <!-- 大屏左下 -->
            <div class="conterCenter">
              <centerLeft3 ref="centerLeft3" />
            </div>
          </div>
          <!-- 大屏中上筛选 -->
          <div class="screenContentCenter">
            <div class="screenList">
              <div class="screenItem" v-if="!value1">
                <div class="screenItemName">
                  选择年份
                </div>
                <el-date-picker placeholder="请选择" class="select" value-format="yyyy" style="width: 94px;height: 34px;" prefix-icon=""
                  v-model="year" type="year"  :picker-options="pickerOptions">
                </el-date-picker>
              </div>
              <div class="screenItem" v-if="!value1 && !month">
                <div class="screenItemName">
                  选择季度
                </div>
                <el-select class="select" style="width: 94px;height: 34px;" v-model="quarter" placeholder="请选择">
                  <el-option v-for="item in quarterOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div class="screenItem" v-if="!quarter && !value1">
                <div class="screenItemName">
                  选择月份
                </div>
                <el-date-picker class="select" value-format="MM" style="width: 94px;height: 34px;" v-model="month"
                  type="month" placeholder="请选择" :picker-options="pickerOptions">
                </el-date-picker>
              </div>
              <div class="screenItem riqi" v-if="!year && !quarter && !month">
                <div class="screenItemName ">
                  选择日期
                </div>
                <el-date-picker class="select" value-format="yyyy-MM-dd" v-model="value1" type="daterange"
                  range-separator="至" start-placeholder="请选择" end-placeholder="请选择" :picker-options="pickerOptions">
                </el-date-picker>
              </div>
              <div class="screenItem riqi" style="margin-right: 0;">

                <div class="queryBtn" style="margin-bottom: 6px;" @click="queryData()">
                  查询
                </div>
                <div class="queryBtn" @click="queryData('reset')">
                  重置
                </div>
              </div>
            </div>
            <div class="map">
              <Map @customEvent="handleCustomEvent" ref="map" />
            </div>
            <div class="mapBottom">
              <div class="center1" style="margin-bottom: 6px">
                <center1 ref="center1" />
              </div>
              <div class="center2">
                <center2 ref="center2" />
              </div>
            </div>
          </div>

          <div class="screenContentRight">
            <!-- 大屏右上 -->
            <div class="conterLeft">
              <centerRight1 ref="centerRight1" />
            </div>

            <!-- 大屏右中 -->
            <div class="conterLeft">
              <centerRight2 ref="centerRight2" />
            </div>
            <!-- 大屏右下 -->
            <div class="conterLeft">
              <centerRight3 ref="centerRight3" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../utils/drawMixin";
import { formatTime } from '../utils/index.js'
import centerLeft1 from './centerLeft1'
import centerLeft2 from './centerLeft2'
import centerLeft3 from './centerLeft3'
import centerRight1 from './centerRight1'
import centerRight2 from './centerRight2'
import centerRight3 from './centerRight3'
import center1 from './center1'
import center2 from './center2'
import Map from './map'
// import bottomRight from './bottomRight'

export default {
  mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      decorationColor: ['#568aea', '#000000'],
      quarterOptions: [
        {
          label: '第一季度',
          value: '01-03'
        },
        {
          label: '第二季度',
          value: '04-06'
        },
        {
          label: '第三季度',
          value: '07-09'
        },
        {
          label: '第四季度',
          value: '10-12'
        },
      ],
      year: '',
      quarter: '',
      month: '',
      value1: '',
      value2: '',
      value: '',
      area: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;//如果不包括今天。就是return time.getTime() > Date.now() - 24*3600*1000;
        }
      }
    }
  },
  components: {
    centerLeft1,
    centerLeft2,
    centerLeft3,
    centerRight1,
    centerRight2,
    centerRight3,
    center1,
    center2,
    Map,
    // bottomRight
  },
  mounted() {
    this.timeFn()
    this.cancelLoading()
  },
  beforeDestroy() {
    clearInterval(this.timing)
  },
  methods: {
    handleCustomEvent(data) {
      // 在此处处理从子组件接收到的数据
      this.area = data
      this.queryData()
    },

    queryData(type) {
      if (type == 'reset') {
        this.year = ''
        this.quarter = ''
        this.month = ''
        this.value1 = ''
        this.area = ''
        this.$refs.map.clearArea()
      }

      let data = {
        year: this.year,
        quarter: this.quarter,
        month: this.month,
        dateBegin: this.value1[0],
        dateEnd: this.value1[1],
        cityName: this.area
      }

      this.$refs.centerLeft3.getMemberPreferences(data)
      this.$refs.centerLeft1.getPositionBarChat(data)
      this.$refs.centerLeft2.getEmploymentRate(data)
      this.$refs.centerRight1.getSalaryDistribution(data)
      this.$refs.centerRight1.getMemberAreaCount(data)
      this.$refs.centerRight2.getSalaryRanking(data)
      this.$refs.centerRight3.getProjectTypeRation(data)
      this.$refs.center1.getStatisticsCount(data)
      this.$refs.center2.getAreaWantRate(data)
    },

    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), 'HH: mm: ss')
        this.dateYear = formatTime(new Date(), 'yyyy-MM-dd')
        this.dateWeek = this.weekday[new Date().getDay()]
      }, 1000)
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.screenHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  padding-top: 42px;

  .screenTitle {
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    white-space: nowrap;
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 4px;
    color: #e8f4ff;
    text-shadow: 0 0 8px rgba(100, 180, 255, 0.55);
    line-height: 33px;
  }

  .screenHeaderTime {
    padding-left: 61px;
    font-size: 18px;
    color: #FFFFFF;
  }

  .userInfo {
    font-size: 18px;
    color: #FFFFFF;
    padding-right: 60px;
    display: flex;
    align-items: center;

    .userAvatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }
}

.headerLineBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 22px;

  .headerLine {
    width: 545px;
    height: 6px;
  }
}

.screenContent {
  position: relative;
  display: flex;
  justify-content: space-between;
}

.screenList {
  position: absolute;
  top: -52px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  z-index: 9;

  .screenItem {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 46px;

    .screenItemName {
      font-size: 18px;
      color: #AEB3BC;
      margin-bottom: 7px
    }
  }

  .riqi {
    align-items: flex-start !important;

    .screenItemName {
      padding-left: 13px;
    }
  }
}

.select {
  ::deep .el-input__prefix {
    display: none
  }
}

.screenContentCenter {
  width: 774px;
}

.queryBtn {
  width: 74px;
  height: 40px;
  background: #192331;
  border-radius: 4px;
  border: 1px solid #28EFEF;
  text-align: center;
  font-size: 18px;
  color: #FFFFFF;
  line-height: 38px;
  cursor: pointer;
}
</style>
<style>
.select .el-input__prefix {
  display: none
}

.select .el-input__icon {
  display: none
}

.el-input--prefix .el-input__inner {
  padding: 0 5px;
  text-align: center;
  background-color: transparent;
}

.el-input--suffix .el-input__inner {
  padding: 0 5px;
  text-align: center;
  background-color: transparent;
  border: none;
  background-image: url('../assets//inputBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff;
}

.el-range-editor .el-input__inner {
  padding: 0 5px;
  text-align: center;
  background-color: transparent;
}

.el-date-editor--daterange {
  padding: 0;
  text-align: center;
  background-color: transparent;
  border: none;
}

.el-range-editor {
  padding: 0 !important;
  width: unset !important;
}

.el-range-input {
  text-align: center;
  background-color: transparent;
  border: none;
  background-image: url('../assets//inputBg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  color: #fff !important;
  border-radius: 4px;
  /* border: 1px solid #DCDFE6 !important; */
  width: 94px !important;
  height: 40px !important;
}

.el-range-separator {
  font-size: 18px !important;
  color: #BDF2FF !important;
  text-shadow: 0px 0px 13px rgba(3, 18, 37, 0.1) !important;
  margin: 0 10px !important;
  display: block !important;
  width: unset !important;
}

.mapBottom {
  position: absolute;
  bottom: 63px;
}
</style>
